/**
 * Table
 */

import { functions } from "../../modules/functions";

export module WysiwygTableWrapModule {
  export class Service {
    constructor(language?: string) {
      document.addEventListener('readCompleteAction', () => {
        Service.wysiwygTableWrapAction();
      });
    }

    /**
     * テーブルのセルにdivを入れる
     */
    public static wysiwygTableWrapAction() {
      let $elements = document.querySelectorAll('.wysiwyg__tableWrap th,.wysiwyg__tableWrap td');
      if ($elements && $elements.length) {
        for (let $i = 0; $i < $elements.length; $i++) {
          let $element = $elements[$i];

          // 要素の追加.
          $element.innerHTML = "<div class='wysiwyg__tableWrapCellInner'>" + $element.innerHTML + "</div>";

        }
      }
    }
  }
}